import { render, staticRenderFns } from "./stock-up-usage-trend.vue?vue&type=template&id=95431d48&scoped=true"
import script from "./stock-up-usage-trend.vue?vue&type=script&lang=js"
export * from "./stock-up-usage-trend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95431d48",
  null
  
)

export default component.exports